// "Recommended" order for the browse grid (admin order within distance bands).
// Kept free of React so it can be unit tested (listingOrder.test.js).

// Distance groups in km. Within each group, the admin's order decides.
export const DISTANCE_BANDS_KM = [15, 40, 100]

const hasRank = (l) => l.admin_rank !== null && l.admin_rank !== undefined

// Ranked listings first (lowest admin_rank first), then unranked ones in
// the order given by `fallback` (distance, or the newest-first order the
// listings arrive in when there's no distance).
const byAdminRank = (fallback) => (a, b) => {
  if (hasRank(a) && hasRank(b)) return a.admin_rank - b.admin_rank
  if (hasRank(a)) return -1
  if (hasRank(b)) return 1
  return fallback(a, b)
}

const bandOf = (km) => {
  const i = DISTANCE_BANDS_KM.findIndex(limit => km < limit)
  return i === -1 ? DISTANCE_BANDS_KM.length : i
}

// listings: already newest-first. distanceOf(listing) → km or null (no location).
export function recommendedSort(listings, distanceOf = null) {
  const indexed = listings.map((l, i) => ({ l, i }))
  const newestFirst = (a, b) => a.i - b.i

  if (!distanceOf) {
    return indexed.sort((a, b) => byAdminRank(newestFirst)(a.l, b.l) || newestFirst(a, b)).map(x => x.l)
  }

  const withKm = indexed.map(x => {
    const km = distanceOf(x.l)
    return { ...x, km: km === null || km === undefined || !isFinite(km) ? Infinity : km }
  })
  return withKm.sort((a, b) => {
    const band = bandOf(a.km) - bandOf(b.km)
    if (band) return band
    return byAdminRank(() => (a.km - b.km) || newestFirst(a, b))(a.l, b.l)
  }).map(x => x.l)
}

// Admin "Arrange" view: the full saved order — ranked first, then the rest newest-first
export const adminOrder = (listings) => recommendedSort(listings, null)
